// ag-grid-react v30.0.5
let counter = 0;
export default function generateNewKey() {
    return `agPortalKey_${++counter}`;
}
